import React from "react";
import localeText from "../../../../locale";
import { formatPrice } from "../../../../utilities/formatPrice";
import { computeSellerNetReceived, isPositiveAmount } from "./orderDetailsUtils";

const OrderDetailsSellerReceivedCard = ({ currentOrder, currencySymbol }) => {
  if (!currentOrder) return null;

  const subtotal = Number(currentOrder.amountOrder) || 0;
  const platformFee = Number(currentOrder.amountToPlatform) || 0;
  const cashback = Number(currentOrder.cashback) || 0;
  const totalReceived = computeSellerNetReceived(currentOrder);

  const showSubtotal = isPositiveAmount(subtotal);
  const showFee = isPositiveAmount(platformFee);
  const showCashback = isPositiveAmount(cashback);
  const showTotal = isPositiveAmount(totalReceived);

  if (!showSubtotal && !showFee && !showCashback && !showTotal) {
    return null;
  }

  return (
    <div className="order-details-card pt-0">
      <div className="order-details-section-title">{localeText("orderDetailsTotalReceived")}</div>
      {showSubtotal && (
        <div className="order-details-summary-row">
          <span>{localeText("orderDetailsSubtotal") || localeText("subtotal")}</span>
          <span>
            {currencySymbol} {formatPrice(subtotal)}
          </span>
        </div>
      )}
      {showFee && (
        <div className="order-details-summary-row">
          <span>{localeText("platformFee")}</span>
          <span>
            - {currencySymbol} {formatPrice(platformFee)}
          </span>
        </div>
      )}
      {showCashback && (
        <div className="order-details-summary-row">
          <span>{localeText("orderDetailsCashback")}</span>
          <span>
            - {currencySymbol} {formatPrice(cashback)}
          </span>
        </div>
      )}
      {showTotal && (
        <div className="order-details-summary-row order-details-summary-row--total">
          <span>{localeText("orderDetailsTotal") || localeText("total")}</span>
          <span>
            {currencySymbol} {formatPrice(totalReceived)}
          </span>
        </div>
      )}
    </div>
  );
};

export default OrderDetailsSellerReceivedCard;
